import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Magnetic from "../components/Magnetic";
import { CALENDLY } from "../data/site";

export default function FinalCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  });
  const glow = useTransform(scrollYProgress, [0, 1], [0.2, 1.6]);
  const glowOp = useTransform(scrollYProgress, [0, 1], [0, 0.5]);

  return (
    <section
      ref={ref}
      id="contact"
      className="relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden px-6 text-center"
      data-testid="final-cta"
    >
      {/* expanding purple accent */}
      <motion.div
        style={{ scale: glow, opacity: glowOp }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-[60vh] w-[60vh] -translate-x-1/2 -translate-y-1/2 rounded-full bg-lav-600 blur-[140px]"
      />

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 text-display uppercase"
      >
        READY TO BUILD
        <br />
        CONTENT THAT
        <br />
        <span className="text-lav-400">SELLS?</span>
      </motion.h2>

      <Magnetic strength={0.5} className="relative z-10 mt-16">
        <a
          href={CALENDLY}
          target="_blank"
          rel="noreferrer"
          data-cursor="OPEN"
          data-testid="final-cta-button"
          className="label group relative inline-flex overflow-hidden border border-white/30 px-10 py-5 text-white"
        >
          <span className="relative z-10 text-sm transition-colors duration-300 group-hover:text-black">
            LET'S TALK ↗
          </span>
          <span className="absolute inset-0 z-0 -translate-y-full bg-lav-400 transition-transform duration-500 ease-lux group-hover:translate-y-0" />
        </a>
      </Magnetic>
    </section>
  );
}
